import { Button, IconName, Link, Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';

interface Props {
    action: () => void;
}

export const CounterTableEmptyHelper = ({ action }: Props) => (
    <Stack itemAlignment="center" vertical spacing="300">
        <div>
            <Button onClick={action} icon={IconName.Add} size="small" variant="tertiary" type="submit">
                <LocalizedText textKey={TextKey.AddCounter} />
            </Button>
        </div>
        <div>
            <Link
                variant="default"
                target="_blank"
                href={createGuideLink(ArticlePath.CreditNoteCounters)}
                rel="noreferrer"
            >
                <LocalizedText textKey={TextKey.CreditNoteCounterTabCreditNoteHelper} />
            </Link>
        </div>
    </Stack>
);
